import React from 'react'
import { SVG } from '../../constants/assetLists';

export interface TabItem {
  value: string;
  label: string;
}

interface TabProps {
  tabs: TabItem[];
  selected: string;
  onChange: (id: string) => void;
}

const AppTabs = ({ tabs, selected, onChange }: TabProps) => {
  return (
    <div className="inline-flex rounded-full overflow-hidden" style={{border: "1px solid #444746"}}>
      {tabs?.map((tab, index) => {
        const isActive = tab.value === selected;
        return (
          <button
            key={tab.value}
            onClick={() => onChange(tab.value)}
            className={`
              flex items-center justify-center w-72 py-2 text-sm font-semibold transition-colors
              ${index !== tabs.length ? "border-r border-[#8c9196]" : ""}
              ${
                isActive
                  ? "!bg-[#1D192B1F] text-[#00A906]"
                  : "bg-white text-[#10415a]"
              }
            `}
          >
            {tab.label}
            {isActive && <img src={SVG.tickGreenIcon} className="w-[14px] h-[12px] mr-3" />}
          </button>
        );
      })}
    </div>
  );
};

export default AppTabs